import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { Button as n } from "../Button/index.js";
import { AddCircleIcon as f } from "../Icons/circle/AddCircleIcon.js";
import { RemoveCircleIcon as d } from "../Icons/circle/RemoveCircleIcon.js";
import { tv as j } from "../tailwind-variants.config.js";
const u = j({
  base: "jm-font-label jm-w-6 jm-text-center jm-select-none jm-cursor-default",
  variants: {
    disabled: {
      true: "jm-text-jutro-new-warm-gray-500",
      false: "jm-text-jutro-new-warm-gray-800"
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), h = ({
  value: e,
  onIncrement: r,
  onDecrement: i,
  disabled: o,
  max: l = 1 / 0,
  min: s = -1 / 0,
  ...a
}) => {
  const m = u({ disabled: o });
  return /* @__PURE__ */ c("div", { ...a, className: "jm-flex jm-w-fit", children: [
    /* @__PURE__ */ t(
      n,
      {
        icon: /* @__PURE__ */ t(d, {}),
        label: "decrement",
        onClick: i,
        disabled: e <= s || o,
        withTooltip: !1,
        full: !1,
        variant: "ghost",
        size: "condensed",
        type: "button"
      }
    ),
    /* @__PURE__ */ t("div", { className: m, children: e }),
    /* @__PURE__ */ t(
      n,
      {
        icon: /* @__PURE__ */ t(f, {}),
        label: "increment",
        onClick: r,
        disabled: e >= l || o,
        withTooltip: !1,
        full: !1,
        variant: "ghost",
        size: "condensed",
        type: "button"
      }
    )
  ] });
};
export {
  h as Counter
};
//# sourceMappingURL=index.js.map
